import { Component, Input, OnInit, PLATFORM_ID, inject } from '@angular/core';
import { LightgalleryModule } from 'lightgallery/angular';
import lgZoom from 'lightgallery/plugins/zoom';
import lgRotate from 'lightgallery/plugins/rotate';
import lgThumbnails from 'lightgallery/plugins/thumbnail';
import lgFullScreen from 'lightgallery/plugins/fullscreen';
import { isPlatformBrowser } from '@angular/common';
import { Asset } from '../../../../graphql/generated/generated-types';
import { LightGallerySettings } from 'lightgallery/lg-settings';
import { RouterLink } from '@angular/router';
import { StateService } from '../../../../core/state/old/state.service';
import { VehicleTypeService } from '../../../services/vehicle-type.service';
import { SelectedModificationService } from '../../../services/selected-modification.service';

@Component({
  selector: 'app-product-image-wrapper',
  standalone: true,
  imports: [RouterLink, LightgalleryModule],
  templateUrl: './product-image-wrapper.component.html',
  styleUrl: './product-image-wrapper.component.scss'
})
export class ProductImageWrapperComponent implements OnInit {
  @Input() slug!: string;
  @Input() images: Asset[] = [];
  @Input() index!: any;
  @Input() showImageExplanation: boolean = false;

  public settings: LightGallerySettings = {
    licenseKey: '9FF17177-7D28-4211-95C3-746BDC180CBE',
    counter: false,
    rotate: true,
    zoom: true,
    plugins: [lgZoom, lgRotate, lgThumbnails, lgFullScreen],
  };

  public isBrowser: boolean = false;
  private platformId: {};


  constructor(private stateService: StateService, public vehicleTypeService: VehicleTypeService,
    public selectedModificationService: SelectedModificationService
  ) {
    this.platformId = inject(PLATFORM_ID);
  }

  ngOnInit(): void {
    this.isBrowser = isPlatformBrowser(this.platformId)
  }

  public openLightGallery(i?: any) {
    if (i > 6) {
      i--;
    }
    const $dynamicGallery = document.getElementById('lightGallery');
    const links = $dynamicGallery!.getElementsByTagName('a');
    if (i !== undefined && i >= 0 && i < links.length) {
      links[i].click();
    }
  }

  public closeCartSidebar() {
    this.stateService.setState('cartSidebarVisible', false);
  }

}
